import { render, staticRenderFns } from "./OpinionTopics.vue?vue&type=template&id=1e6d898f&scoped=true&"
import script from "./OpinionTopics.vue?vue&type=script&lang=js&"
export * from "./OpinionTopics.vue?vue&type=script&lang=js&"
import style0 from "./OpinionTopics.vue?vue&type=style&index=0&id=1e6d898f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6d898f",
  null
  
)

export default component.exports